import React, { FunctionComponent } from 'react';
import { Box, Grid, Link, useTheme } from '@material-ui/core';
import { useReactiveVar } from '@apollo/client';
import { ISpcTheme } from '../../../../../common/theme/ISpcTheme';
import Translation from '../../../../../gqlCommon/components/translation/Translation';
import KeyFeatures from './keyFeatures/KeyFeatures';
import specificationsAndFeaturesStyles from './specificationsAndFeaturesStyles';
import Specifications from './specifications/Specifications';
import { GetCustomizeCarModel_customizeCar_car_keyFeatures } from '../../../../graphql/queries/__generated__/GetCustomizeCarModel';
import { brochureUrlVar } from '../../../../../gqlCommon/graphql/cache';

export interface ISpecificationsAndFeaturesProps {
  keyFeatures: GetCustomizeCarModel_customizeCar_car_keyFeatures[];
  openModal: () => void;
  specifications?: string[];
}

const SpecificationsAndFeatures: FunctionComponent<ISpecificationsAndFeaturesProps> = ({
  keyFeatures,
  openModal,
  specifications,
}) => {
  const styles = specificationsAndFeaturesStyles();
  const {
    spc: {
      customise: { hideViewSpecificationsFeaturesLink, showBrochureLinkInSummary, displayBrochureUrlOnNextRow },
    },
  } = useTheme<ISpcTheme>();
  const brochureUrl = useReactiveVar(brochureUrlVar);

  return (
    <Box data-test="customise:specificationFeaturesContent">
      <Specifications specifications={specifications} />
      <KeyFeatures keyFeatures={keyFeatures} />
      <Grid container={true} className={styles.linksContainer}>
        <>
          {!hideViewSpecificationsFeaturesLink && (
            <Grid item={true} xs={!displayBrochureUrlOnNextRow && brochureUrl ? 8 : 12}>
              <Box>
                <Link
                  onClick={openModal}
                  variant="caption"
                  className={styles.viewSpecificationsFeaturesLink}
                  data-test="customise:viewSpecificationsFeaturesLink"
                >
                  <Translation id="trans__configurator__customise_page_variant_section__view_full_specs" />
                </Link>
              </Box>
            </Grid>
          )}

          {!!brochureUrl && !showBrochureLinkInSummary && (
            <Grid item={true} xs={displayBrochureUrlOnNextRow ? 12 : 4}>
              <Box className={styles.brochureLinkWrapper}>
                <Link
                  variant="caption"
                  className={styles.brochureLink}
                  href={brochureUrl}
                  target={'_blank'}
                  data-test="customise:link:brochure"
                >
                  <Translation id="trans__configurator__customise_page_variant_section__download_brochure_link" />
                </Link>
              </Box>
            </Grid>
          )}
        </>
      </Grid>
    </Box>
  );
};

export default SpecificationsAndFeatures;
